var languageContainer = document.getElementById("languageModalContainer");
var languageModal = document.getElementById("languageModal");
var lngBtn = document.getElementById("languageBtn");
var langSpan = document.getElementsByClassName("lang-close-modal")[0];
var modalContainer2 = document.getElementById("loginModalContainer");
var modal2 = document.getElementById("loginModal");

if (lngBtn) {
  lngBtn.onclick = function () {
    modalContainer2?.classList.remove("show");
    modal2?.classList.remove("slide-up");
    languageContainer.classList.add("show");
    languageModal.classList.add("slide-up");
  };
}
langSpan.onclick = function () {
  languageContainer.classList.remove("show");
  languageModal.classList.remove("slide-up");
};

document.addEventListener("focusin", function (event) {
  if (!languageModal.contains(event.target)) {
    languageContainer.classList.remove("show");
    languageModal.classList.remove("slide-up");
  }
});

const onItemClick = (event) => {
  event.preventDefault();
  const form = document.getElementById("language-switch-desktop");
  const input = form.querySelector("input[name=country_code]");
  input.value = event.currentTarget.dataset.value;
  const datasetValue = event.currentTarget.dataset.value;
  console.log("datasetValue", datasetValue, window.location.pathname);
    if (datasetValue === 'default') {
      window.location.href = event.currentTarget.href;
      return;

  } else if (datasetValue == "IT") {
    if (
      !window.location.pathname.includes("/en/") &&
      !window.location.pathname.includes("/en-us/")&&
      !window.location.pathname.includes("/en-ch/")&&
      !window.location.pathname.includes("/en-au/")&&
      !window.location.pathname.includes("/en-ca/")&&
      !window.location.pathname.includes("/en-gb/")
    ) {
      return;
    }
  }
  fetch(form.action, {
    method: "POST",
    body: new FormData(form),
  }).then(function (response) {
    if (response.ok) {
     let languageCode;

     switch (datasetValue) {
                case "IT":
                  languageCode = "it";
                  break;
                case "US":
                  languageCode = "en-us";
                  break;
                case "CH":
                  languageCode = "en-ch";
                  break;
                case "AU":
                  languageCode = "en-au";
                  break;
                case "CA":
                  languageCode = "en-ca";
                  break;
                case "GB":
                  languageCode = "en-gb";
                  break;
                default:
                  languageCode = "en";
              }

console.log("languageCode:", languageCode);
        console.log("languageCode", languageCode);
      //check here  datasetValue == "IT" ? "it" : datasetValue == "US" ? "en-us" : "en";

      var currentUrl = window.location.href;
      var newUrl;

      // Check if the current URL already has a language prefix
      var urlParts = currentUrl.split("/");
      console.log("urlParts",urlParts);
      // if language code is IT compose the new url without language code
      if (languageCode == "it") {
        urlParts.splice(3, 1);
        newUrl = urlParts.join("/");
      } else if (urlParts[3].length === 2) {
        // Assuming the language code is 2 characters long
        // Replace the current language code with the new one
        urlParts[3] = languageCode;
        newUrl = urlParts.join("/");
      } else {
        // check urlParts contains en-us or en and remove it before adding new language code
              if (urlParts[3] == "en-us" || urlParts[3] == "en" || urlParts[3] == "en-ch"|| urlParts[3] == "en-au"|| urlParts[3] == "en-ca"|| urlParts[3] == "en-gb") {
          urlParts.splice(3, 1);
        }
        urlParts.splice(3, 0, languageCode);
        newUrl = urlParts.join("/");
      }
      window.location.href = newUrl;
    } else {
      // Handle form submission error
      console.error("Form submission failed.", response);
    }
  });
};

// for all a elements of languageModal
languageModal
  ?.querySelectorAll("a")
  .forEach((item) => item.addEventListener("click", onItemClick));
